import { OPERATIONAL_MODULE_SLUGS } from "@shared/api/server/gs3Server";

/** `moduleKey` canônico a partir de `/<slug>` (índice do módulo, sem structureId). */
export const resolveOperationalModuleFromIndexPath = (
  pathname: string,
): string | undefined => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length !== 1) {
    return undefined;
  }

  const [slug] = segments;
  return Object.entries(OPERATIONAL_MODULE_SLUGS).find(
    ([, moduleSlug]) => moduleSlug === slug,
  )?.[0];
};

/** Mapa `/<slug>` → `moduleKey` para interceptar cliques na sidebar. */
export const OPERATIONAL_MODULE_PATH_TO_KEY: Record<string, string> =
  Object.fromEntries(
    Object.entries(OPERATIONAL_MODULE_SLUGS).map(([moduleKey, slug]) => [
      `/${slug}`,
      moduleKey,
    ]),
  );

export const isOperationalStructurePath = (pathname: string): boolean => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length !== 2) {
    return false;
  }

  const [slug] = segments;
  return Object.values(OPERATIONAL_MODULE_SLUGS).includes(slug);
};
